export default __webpack_public_path__ + "static/media/ng.a6e83787.svg";